import dayjs from 'dayjs';
import SuperFetch from 'library/helpers/superFetch';
import { removeEmptyOrNull } from 'library/helpers/utility';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { accessLogsActions } from './slice';

const defaultFilters = {
	page: 1,
	pageSize: 10,
	personIDs: [],
	deviceIDs: [],
	dateFrom: dayjs().subtract(1, 'month').startOf('day').toISOString(),
	dateTo: dayjs().endOf('day').toISOString()
};

function* fetchAccessLogs() {
	try {
		const { orgID } = yield select((state) => state.Auth.selectedProfile);
		const filters = (yield select((state) => state.AccessLogs.filters[orgID])) || {
			...defaultFilters
		};

		const {
			page = 1,
			pageSize = 10,
			dateFrom,
			dateTo,
			personIDs = [],
			deviceIDs = [],
			status,
			integrationID
		} = filters;

		const params = removeEmptyOrNull({
			orgID,
			page,
			pageSize,
			dateFrom: dateFrom ? new Date(dateFrom).toISOString() : undefined,
			dateTo: dateTo ? new Date(dateTo).toISOString() : undefined,
			personIDs: personIDs.length ? personIDs.join(',') : undefined,
			deviceIDs: deviceIDs.length ? deviceIDs.join(',') : undefined,
			status: status && status !== 'All' ? status.toLowerCase() : undefined,
			integrationID: integrationID || undefined
		});

		const logs = yield call(() => SuperFetch.get('/logs/accessLogs', {}, params));

		if (logs.statusCode === 200) {
			yield put(
				accessLogsActions.loadAccessLogsSuccess({
					orgID,
					data: logs.data,
					total: logs.pagination?.total || 0
				})
			);
		} else {
			throw new Error(logs.message || 'Failed to load access logs.');
		}
	} catch (error) {
		yield put(accessLogsActions.loadAccessLogsError(error));
	}
}

export default function* accessLogsSaga() {
	yield takeLatest(accessLogsActions.loadAccessLogs, fetchAccessLogs);
	yield takeLatest(accessLogsActions.setAccessLogsFilters, fetchAccessLogs);
}
